<template>
    <div>
        <div class="TTL-dialog">
        <el-dialog v-model="Genealogyparam.view" title="新增 / 编辑族谱人员" width="25%" :before-close="closeBefore">
            <el-form :model="form" align="center" v-loading="Genealogyparam.loading">
                <el-form-item>
                    <div class="TTL-setting-image-detail">
                    <el-image
                        width="150"
                        height="150"
                        :src="Genealogyparam.thumb ? Genealogyparam.thumb : require('@/assets/avatar/avatar_default.png')"
                        :zoom-rate="1.2"
                        :preview-src-list="Genealogyparam.thumb ? [Genealogyparam.thumb] : []"
                        :initial-index="4"
                        fit="cover"
                    />
                    <div class="TTL-setting-image-btn">
                    <el-button size="small" type="warning" icon="EditPen" circle  @click="editThumbs" />
                    </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="Genealogyparam.name" placeholder="请填写族谱人员名称" round size="large" prefix-icon="User" clearable/>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="Genealogyparam.othername" placeholder="请填写族谱人员别名（没有可不填）" round size="large" prefix-icon="User" clearable/>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="Genealogyparam.work" placeholder="成员职业或生前职业" round size="large" prefix-icon="Basketball" clearable/>
                </el-form-item>
                <el-form-item>
                    <el-input type="textarea" rows="5" v-model="Genealogyparam.description" placeholder="成员描述" round size="large" :prefix-icon="Search"/>
                </el-form-item>
                <el-form-item>
                    <el-input v-model="Genealogyparam.sort" placeholder="排序" round size="large" prefix-icon="Position" clearable/>
                </el-form-item>
                <el-form-item>
                    <el-radio-group v-model="Genealogyparam.sex">
                        <el-radio :label="0">男</el-radio>
                        <el-radio :label="1">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-radio-group v-model="Genealogyparam.isrelatives">
                        <el-radio :label="0">祖传嫡系</el-radio>
                        <el-radio :label="1">外嫁过来</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item>
                    <el-radio-group v-model="Genealogyparam.isexit">
                        <el-radio :label="0">在世</el-radio>
                        <el-radio :label="1">已离世</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="Genealogyparam.isexit==1">
                    <el-input v-model="Genealogyparam.grave_area" placeholder="埋葬地" round size="large" prefix-icon="Position" clearable/>
                </el-form-item>
                <el-form-item v-if="Genealogyparam.isexit==1">
                    <el-input v-model="Genealogyparam.grave_longitude" placeholder="埋葬精度" round size="large" prefix-icon="Position" clearable/>
                </el-form-item>
                <el-form-item v-if="Genealogyparam.isexit==1">
                    <el-input v-model="Genealogyparam.grave_latitude" placeholder="埋葬维度" round size="large" prefix-icon="Position" clearable/>
                </el-form-item>
                <el-form-item>
                    <div class="TTL-footer">
                        <el-button type="warning" size="large" round @click="saveGenealogy">保存</el-button>
                        <el-button size="large" round @click="Genealogyparam.view=false">取消</el-button>
                    </div>
                </el-form-item>
            </el-form>
        </el-dialog>    

        <!-- 自定义组件 -->
        <!-- 图片上传组件 -->
        <div><input type="file" id="genealogyAddOrEdit" style="display:none;" @change="getgenealogyImageUrl"/></div>

        </div>
    </div>
</template>


<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
export default {
    props: ['value','data','type'],
    data() {
        return {
            
            /** 操作类型 **/
            acttype:'add',
            
            /** 族谱成员 **/
            Genealogyparam: {
                id:'',
                genealogyid:'',
                name:'',
                othername:'',
                pid:'',
                description:'',
                work:'',
                thumb:'',
                sex:'',
                isexit:'',
                isrelatives:'',
                grave_area:'',
                grave_longitude:'',
                grave_latitude:'',
                sort:'',
                view:false,
                loading:false,
            },

            /** 图片上传 **/
            imageUploadParam: {
                type:'genealogy',
                imagetype:'avar',
            },

        }
    },

    watch: {
        value(val) {
            if(val) {
                this.Genealogyparam.view=true;
                this.acttype=this.type;
                this.resetparam(); //重置提交数据
                if(this.acttype=='add') this.setAddParam(); //设置成员数据
                if(this.acttype=='edit') this.setParam(); //设置成员数据
            }
        },
    },

    mounted() {
        
    },

    methods: {


        /**
         * 保存族谱成员
        */
        saveGenealogy() {
            this.Genealogyparam.loading=true;
            INTERFACE_MODEL_GENEALOGY.ADD_OR_EDIT_GENEALOGY_MEMBER(this.Genealogyparam).then((res) => {
                this.Genealogyparam.loading=false;
                if(res.status > 0) return false;
                this.closeBefore(); //关闭窗口
            });
        },


        /** 
         * 编辑头像
        */
        editThumbs() {
            document.getElementById('genealogyAddOrEdit').click();
        },


        /**
         * 获取返回的商品图片url
        */
        getgenealogyImageUrl(e) {
            let _this=this;
            let file=e.target.files[0]; //获取文件
            e.target.value=''; //清空数据

            //上传图片到接口操作
            INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:_this.imageUploadParam.imagetype,File:file}).then((res) => {
                if(res.status > 0) return false;
                let url=this.$ImageAddress+res.data.url;
                if(_this.imageUploadParam.type=='genealogy') _this.Genealogyparam.thumb=url; 
            });
        },


        /*
         * 设置成员数据
        */
        setParam() {
            let data=this.data;
            this.Genealogyparam.id=data.id > 0 ? data.id : '';
            this.Genealogyparam.genealogyid=data.genealogyid > 0 ? data.genealogyid : '';
            this.Genealogyparam.name=data.name ? data.name : '';
            this.Genealogyparam.othername=data.othername ? data.othername : '';
            this.Genealogyparam.pid=data.pid > 0 ? data.pid : '';
            this.Genealogyparam.description=data.description ? data.description : '';
            this.Genealogyparam.work=data.work ? data.work : '';
            this.Genealogyparam.thumb=data.image_url ? data.image_url : '';
            this.Genealogyparam.sex=data.sex ? data.sex : 0;
            this.Genealogyparam.isexit=data.isexit ? data.isexit : 0;
            this.Genealogyparam.isrelatives=data.isrelatives ? data.isrelatives : 0;
            this.Genealogyparam.grave_area=data.grave_area ? data.grave_area : '';
            this.Genealogyparam.grave_longitude=data.grave_longitude ? data.grave_longitude : '';
            this.Genealogyparam.grave_latitude=data.grave_latitude ? data.grave_latitude : '';
            this.Genealogyparam.sort=data.sort > 0 ? data.sort : '';
        },


        /**
         * 设置新增成员数据
        */
        setAddParam() {
            let data=this.data;
            this.Genealogyparam.genealogyid=data.genealogyid > 0 ? data.genealogyid : '';
            this.Genealogyparam.pid=data.id > 0 ? data.id : '';
        },


        /**
         * 重置提交数据
        */
        resetparam() {
            this.Genealogyparam.id='';
            this.Genealogyparam.genealogyid='';
            this.Genealogyparam.name='';
            this.Genealogyparam.othername='';
            this.Genealogyparam.pid='';
            this.Genealogyparam.description='';
            this.Genealogyparam.work='';
            this.Genealogyparam.thumb='';
            this.Genealogyparam.sex='';
            this.Genealogyparam.isexit='';
            this.Genealogyparam.isrelatives='';
            this.Genealogyparam.grave_area='';
            this.Genealogyparam.grave_longitude='';
            this.Genealogyparam.grave_latitude='';
            this.Genealogyparam.sort='';
        },


        /**
         * 关闭窗口
        */
        closeBefore() {
            this.Genealogyparam.view=false;
            this.$emit('genealogyeditfinish','closewindow');
        },

    },

}
</script>
<style scoped>
.TTL-dialog {text-align:left !important;}
.TTL-setting-image-detail {width:80px;height:80px;text-align:center;margin:0 auto;}
.TTL-setting-image-detail .el-image {width:80px;height:80px;border-radius:50%;}
</style>